/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getPurchases } from "./../../helpers/purchases";
import { useSelector } from "react-redux";
import {
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  Skeleton,
  Tabs,
  Tab
} from "@mui/material";
import moment from "moment";
import { ArrowRightThin } from "mdi-material-ui";

const Trades = (props) => {
  // state
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]); 
  const [tab, setTab] = useState(0);

  // redux
  const { token } = useSelector((state) => state.app);

  // lifecycles
  useEffect(() => {
    props.history.push(`/dashboard/trades?type=${tab}`);
    if(tab === 0) {
      handleGetPurchases();
    } else if(tab === 1) {
      handleGetPurchases(0,"62361e1a2a1ce4772f21ab77");
    } else {
      handleGetPurchases(0,null,"62361e1a2a1ce4772f21ab77");
    }
  }, [tab]);

  // methods
  const handleTabChange = (e, newValue) => {
    setTab(newValue);
  }

  const handleGetPurchases = async (start = 0, from, to) => {
    try {
      const [, response] = await getPurchases(token,start,from,to);
      setList(response.data);
      setLoading(false);
    } catch(err) {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6" className="mb-3">
        Trades
      </Typography> 
      <div className="d-flex">
        <Tabs 
          value={tab} 
          onChange={handleTabChange}
          className="mb-3 fancyTabs"
          >
          <Tab label="All Trades"/>
          <Tab label="Buy"/>
          <Tab label="Sell"/>
        </Tabs>
      </div>     
      
      <div className="row">
        <div className="col-12">
          <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Traded Assets</TableCell>
                  <TableCell align="left">Amount</TableCell>
                  <TableCell align="left">Total</TableCell>
                  <TableCell align="left">Price per unit</TableCell>
                  <TableCell align="right">Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (
                  <TableRow>
                    <TableCell colSpan="5">
                      <Skeleton/>
                      <Skeleton/>
                      <Skeleton/>
                    </TableCell>
                  </TableRow>
                )}
                {!loading && list.length === 0 && (
                  <TableRow>
                    <TableCell className="text-center" sx={{ border: 0 }} colSpan={4}>
                      <Typography my={2} variant="body2">You don't have any trades yet.</Typography>
                    </TableCell>
                  </TableRow>
                )}
                {!loading && list.length > 0 && (
                  <>
                    {list.map((item, i) => (
                      <TableRow
                        hover={true}
                        key={i}
                        sx={{ 
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell align="left">
                          <div className="d-flex align-items-center">
                            {item.from.display_symbol} <ArrowRightThin/> {item.to.display_symbol}
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          {item.amount} { 
                            item.to.symbol === "tether" ? item.from.display_symbol : item.to.display_symbol
                          }
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                        >
                          {
                            parseFloat(item.value).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })
                          }
                        </TableCell>
                        <TableCell align="left">
                          {
                            parseFloat(item.value/item.amount).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })
                          }
                        </TableCell>
                        <TableCell align="right">
                          {moment(item.createdAt).format(
                            "MMM D YYYY, h:mm a"
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};
export default Trades;
